module.exports = __webpack_public_path__ + "img/chadle_adv_24.f8da4218.png";